<template>
  <div id="store">
    <el-tabs type="border-card">
      <el-tab-pane label="库存明细">
        <div class="lv3Text t1">我的全部库存明细</div>
        <div class="lv4Text t2" v-if="isEmpty">目前没有库存记录</div>
        <div v-else>
          <el-table :data="tableData" style="width: 100%" border>
            <el-table-column prop="project" label="项目名称"></el-table-column>
            <el-table-column prop="title" label="名称" width="180"></el-table-column>
            <el-table-column prop="item_no" label="货号" width="180"></el-table-column>
            <el-table-column label="购买时间">
              <template
                slot-scope="scope"
              >{{dayjs.unix(scope.row.create_date).format("YYYY-MM-DD")}}</template>
            </el-table-column>
            <el-table-column prop="number" label="剩余" width="80px"></el-table-column>
            <el-table-column prop="specification" label="规格" width="100px"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="openEdit(scope.row.id)">修改</el-button>
                <el-popover
                  placement="top"
                  width="160"
                  v-model="visibles[scope.row.id]"
                  style="margin-left:10px;"
                >
                  <p>确定删除吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="cancel(scope.row.id)">取消</el-button>
                    <el-button type="primary" size="mini" @click="del(scope.row.id)">确定</el-button>
                  </div>
                  <el-button type="text" slot="reference" size="small">删除</el-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-top:20px;" class="btns">
          <el-button type="primary" @click="openAdd()" size="mini">
            <i class="fas fa-plus-circle"></i>添加库存
          </el-button>
          <span style="display:inline-block;margin-left:10px">
            <el-upload
              action="http://www.daimumu.cn:81/personal/upload_inventory"
              :show-file-list="false"
              :on-success="handleSuccess"
              name="inventory"
              :data="{mobile:mobile,token:token}"
            >
              <el-button type="primary" size="mini" style="margin-right:10px">
                <i class="el-icon-upload el-icon--right"></i>批量上传
              </el-button>
            </el-upload>
          </span>

          <a
            :href="serve + '/personal/download_excel?mobile='+mobile+'&token='+token"
            target="blank"
          >
            <el-button type="primary" size="mini">
              <i class="fas fa-file-download"></i>下载模板
            </el-button>
          </a>
        </div>
        <div class="pager" align="center">
          <el-pagination
            background
            hide-on-single-page
            layout="prev, pager, next"
            :total="total"
            :page-size="15"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="使用记录">
        <div style="width:230px;margin:10px 0;margin-bottom:20px;">
          <el-input placeholder="请输入货号或者商品名称" v-model="keyword" size="mini">
            <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
          </el-input>
        </div>
        <el-table :data="tableData2" style="width: 100%" border>
          <el-table-column prop="title" label="商品名称"></el-table-column>
          <el-table-column prop="item_no" label="货号"></el-table-column>
          <el-table-column label="使用日期">
            <template slot-scope="scope">{{dayjs.unix(scope.row.create_date).format("YYYY-MM-DD")}}</template>
          </el-table-column>
          <el-table-column prop="change_user" label="操作人"></el-table-column>
          <el-table-column prop="number" label="剩余" width="80px"></el-table-column>
          <el-table-column prop="string" label="使用"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small">删除</el-button>
              <el-button type="text" size="small" @click="openRemark(scope.row.info)">备注</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pager" align="center">
          <el-pagination
            background
            hide-on-single-page
            layout="prev, pager, next"
            :total="total2"
            :page-size="20"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="添加库存" :visible.sync="addDialog" width="50%" @closed="handleClose">
      <div style="padding:20px 150px">
        <el-form label-position="right" label-width="100px">
          <el-form-item label="项目名称：">
            <el-select v-model="form.project" placeholder="请选择">
              <el-option
                v-for="item in projects"
                :key="item.id"
                :label="item.project_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品分类：">
            <el-select v-model="form.category" placeholder="请选择" @change="getMoney">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="余额：" class="lv0Text">&yen;{{money}}</el-form-item>
          <el-form-item label="商品名称：">
            <el-input v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="商品货号：">
            <el-input v-model="form.item_no"></el-input>
          </el-form-item>
          <el-form-item label="数量：" maxlength="“10">
            <el-input v-model="form.number" style="width:180px"></el-input>
          </el-form-item>
          <el-form-item label="规格：" maxlength="“10">
            <el-input v-model="form.specification" style="width:180px"></el-input>
          </el-form-item>
          <el-form-item label="总金额：">
            <el-input v-model="form.money"></el-input>
          </el-form-item>
          <el-form-item label="备注：" maxlength="“10">
            <el-input v-model="form.info" type="textarea"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="add" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改库存" :visible.sync="editDialog" width="40%" @closed="handleClose">
      <div style="padding:0 50px">
        <el-form label-position="right" label-width="100px">
          <el-form-item label="修改数量：">
            <el-switch
              style="line-height:20px;margin-right:20px"
              v-model="form2.sign"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="增加"
              inactive-text="减少"
              active-value="1"
              inactive-value="0"
            ></el-switch>
            <el-input-number size="small" v-model="form2.number" :min="1" :max="999"></el-input-number>
          </el-form-item>
          <el-form-item label="操作人">
            <el-input v-model="form2.change_user" placeholder="请输入操作人姓名"></el-input>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input type="textarea" v-model="form2.info"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="edit" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="remarkDialog" width="50%" @close="handleClose">
      <span>{{remark}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="remarkDialog = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="选择文件" :visible.sync="inputDialog" width="30%">
      <span>
        <input ref="input" type="file" @change="getFile">
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="inputDialog = false">取 消</el-button>
        <el-button type="primary" @click="uploadExcel">上传</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      //
      remarkDialog: false,
      currentPage: 1,
      keyword: "",
      money: 0,
      projects: null,
      visibles: [],
      page: 1,
      tableData: null,
      isEmpty: null,
      isEmpty2: null,
      tableData2: null,
      addDialog: false,
      form: {},
      form2: {
        number: 1
      },
      options: [
        {
          value: "试剂",
          label: "试剂"
        },
        {
          value: "耗材",
          label: "耗材"
        },
        {
          value: "抗体",
          label: "抗体"
        },
        {
          value: "设备",
          label: "设备"
        },
        {
          value: "技术服务",
          label: "技术服务"
        }
      ],
      loading: false,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      historyData: null,
      total: 0,
      total2: 0,
      editDialog: false,
      remark: "",
      isEmpty2: true,
      excel: null,
      inputDialog: false
    };
  },
  created() {
    //
    this.initData();
  },
  mounted() {
    this.$store.state.user_location = "我的库存";
  },
  methods: {
    //
    handleSuccess(res, file, fileList) {
      if (res.status == "success") {
        this.$message("上传成功");
        this.initData();
      }
    },
    uploadExcel() {
      let param = new FormData();
      param.append("mobile", this.mobile);
      param.append("token", this.token);
      param.append("inventory", this.excel);
      // for (var pair of param.entries()) {
      //   console.log(pair[0] + ", " + pair[1]);
      // }
      let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      this.axios
        .post(
          this.serve + "/personal/upload_inventory",
          param,
          config
        )
        .then(response => {
        });
    },
    open() {
      this.inputDialog = true;
    },
    getFile(e) {
      let files = e.target.files || e.dataTransfer.files;
      this.excel = e.target.files[0];
    },
    handleClose() {
      this.remark = "";
    },
    openRemark(string) {
      this.remarkDialog = true;
      this.remark = string;
    },
    search() {
      this.axios
        .get(this.serve + "/personal/use_inventory_log", {
          params: {
            mobile: this.mobile,
            token: this.token,
            key: this.keyword,
            page: 1
          }
        })
        .then(res => {
          if (res.data.msg == "搜索结果为空") {
            this.isEmpty2 = true;
            this.tableData2 = [];
          } else {
            this.currentPage = 1;
            this.isEmpty2 = false;
            this.tableData2 = res.data.data.results;
            for (var item of this.tableData2) {
              var arr = item.change.split("");
              if (arr[0] == "-") {
                item.string = "减少" + arr[1] + "个";
              } else if (arr[0] == "+") {
                item.string = "增加" + arr[1] + "个";
              }
            }
            this.total2 = res.data.data.total;
          }
        });
    },
    getMoney(v) {
      if (this.form.project && this.form.category) {
        this.axios
          .get(this.serve + "/personal/project_money", {
            params: {
              mobile: this.mobile,
              token: this.token,
              project: this.form.project,
              category: this.form.category
            }
          })
          .then(res => {
            if ((res.data.status = "success")) {
              this.money = res.data.data;
            }
          });
      }
    },
    openAdd() {
      this.addDialog = true;
    },
    del(id) {
      const loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });
      this.axios
        .get(this.serve + "/personal/del_inventory", {
          params: {
            mobile: this.mobile,
            token: this.token,
            id: id
          }
        })
        .then(res => {
          if ((res.data.status = "success")) {
            loading.close();
            this.$set(this.visibles, id, false);
            this.initData();
            this.$message("库存已删除");
          }
        });
    },
    cancel(index) {
      this.$set(this.visibles, index, false);
    },
    openEdit(id) {
      this.editDialog = true;
      this.form2.id = id;
    },
    edit() {
      this.loading = true;
      this.form2.mobile = this.mobile;
      this.form2.token = this.token;
      this.axios
        .get(this.serve + "/personal/change_inventory", {
          params: this.form2
        })
        .then(res => {
          this.loading = false;
          if (res.data.status == "success") {
            this.editDialog = false;
            this.initData();
          } else if (res.data.msg) {
            this.$message.error(res.data.msg);
          }
        });
    },
    add() {
      this.loading = true;
      this.form.mobile = this.mobile;
      this.form.token = this.token;
      this.axios
        .get(this.serve + "/personal/add_user_inventory", {
          params: this.form
        })
        .then(res => {
          this.loading = false;
          if (res.data.status == "success") {
            this.initData();
            this.loading = false;
            this.addDialog = false;
            this.$message({
              title: "成功",
              message: "库存添加完成",
              type: "success"
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    handleClose() {
      this.form = {};
      this.form2.number = 1;
      this.form2.id = null;
    },
    initData() {
      this.axios
        .get(this.serve + "/personal/user_inventory_list", {
          params: {
            mobile: this.mobile,
            token: this.token,
            page: this.page
          }
        })
        .then(res => {
          if (res.data.msg == "搜索结果为空") {
            this.isEmpty = true;
          } else {
            this.isEmpty = false;
            this.tableData = res.data.data.results;
          }
        });

      this.axios
        .get(this.serve + "/personal/my_project_list", {
          params: {
            mobile: this.mobile,
            token: this.token
          }
        })
        .then(res => {
          this.projects = res.data.data;
        });

      this.axios
        .get(this.serve + "/personal/use_inventory_log", {
          params: {
            mobile: this.mobile,
            token: this.token
          }
        })
        .then(res => {
          if (res.data.msg == "搜索结果为空") {
            this.isEmpty2 = true;
          } else {
            this.isEmpty2 = false;
            this.tableData2 = res.data.data.results;
            for (var item of this.tableData2) {
              var arr = item.change.split("");
              if (arr[0] == "-") {
                item.string = "减少" + arr[1] + "个";
              } else if (arr[0] == "+") {
                item.string = "增加" + arr[1] + "个";
              }
            }
            this.total2 = res.data.data.total;
          }
        });
    }
  }
};
</script>
<style lang="scss">
#store {
  .btns {
    svg,
    .el-icon-upload {
      margin-right: 5px;
    }
  }
  .t1 {
    margin: 10px 0;
    margin-bottom: 20px;
  }
  .t2 {
    text-align: center;
    padding: 30px 0;
  }
  .fa-plus {
    margin-right: 5px;
  }
}
</style>